// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"419af466","438":"6ffd9ba1","787":"f01b75f8"}[chunkId] + ".chunk.js";
};